import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiResponseMessages } from '../../../../projects/ppb-shared-library/src/lib/models/global.model';
import { PpbApiService } from '../shared/services/ppb-api.service';
import { InvitationComponentState, InvitationResponse } from './invitation.model';

@Component({
  selector: 'ppb-invitation',
  templateUrl: './ppb-invitation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PpbInvitationComponent implements OnInit {
  code: string;
  invitationInfo: InvitationResponse;
  partnersNames: string;
  error: ApiResponseMessages = null;
  isLoading$ = new BehaviorSubject(true);
  state: InvitationComponentState = 'INVITE';

  constructor(
    private route: ActivatedRoute,
    private api: PpbApiService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.code = this.route.snapshot.params.code;
    if (this.code) {
      this.fetchInvitation(this.code)
        .subscribe((resp: InvitationResponse) => {
            this.invitationInfo = resp;
            this.partnersNames = resp.abpbPartners.map(p => p.name).join(', ');
            this.isLoading$.next(false);
          },
          (_err) => {
            this.error = _err.error;
            this.isLoading$.next(false);
          }
        )
    }
  }

  fetchInvitation(code: string): Observable<InvitationResponse> {
    return this.api.getPublic(`/api/v1/invitations/check?code=${code}`);
  }

  handleInvitation(action: 'ACCEPT' | 'REJECT'): void {
    this.api.postPublic(`/api/v1/invitations/action`, {
      code: this.code,
      action
    })
      .subscribe(() => {
        this.isLoading$.next(false);
        this.state = action;
      }, (_err) => {
        this.error = _err.error;
        this.isLoading$.next(false);
      });
  }

  getErrors(error: ApiResponseMessages): string {
    return error.messages.map(e => e.description).join(' ');
  }

  goToHomePage(): void {
    this.router.navigate(['/']);
  }
}
